<template>
  <div><RegisterForm :id="1" /></div>
</template>

<script>
import RegisterForm from "@/components/RegisterForm.vue";
export default {
  name: "PersonalForm",
  components: {
    RegisterForm,
  },
};
</script>

<style></style>
